import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { RiskLevelIndicator, riskLevelIndicatorChoices, riskLevelIndicatorImage } from "./riskLevelIndicators";
import { useRiskLevelStyles } from "./riskLevels.styles";

export interface IRiskLevelIndicatorPicker {
    value: RiskLevelIndicator;
    onChange: (indicator: RiskLevelIndicator) => void;
}

export function RiskLevelIndicatorPicker(props: IRiskLevelIndicatorPicker) {
    const styles = useRiskLevelStyles();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const close = () => setAnchorEl(null);

    const select = (indicator: RiskLevelIndicator) => {
        props.onChange(indicator);
        close();
    };

    return (
        <>
            <IconButton sx={styles.iconPickerButton} onClick={(event) => setAnchorEl(event.currentTarget)}>
                {riskLevelIndicatorImage(props.value)}
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={close}>
                {riskLevelIndicatorChoices.map((indicator) => (
                    <MenuItem key={indicator} sx={styles.iconPickerMenuItem} onClick={() => select(indicator)}>
                        {riskLevelIndicatorImage(indicator)}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
